export interface IInspectionListEntity {
  shipment_id: string;
  started_at: string;
  ended_at: string;
  requested_at: string;
  status: string;
  code: string;
}

export class InspectionListEntity {
  shipmentId: string;
  startedAt: string;
  endedAt: string;
  requestedAt: string;
  status: string;
  code: string;

  static create(data: IInspectionListEntity): InspectionListEntity {
    try {
      if (!data || typeof data !== 'object') {
        throw new Error('Invalid data: data must be an object');
      }

      return new InspectionListEntity(data);
    } catch (error: any) {
      throw new Error(`Error creating InspectionEntity: ${error.message}`);
    }
  }

  constructor(data: IInspectionListEntity) {
    this.shipmentId = data.shipment_id;
    this.startedAt = data.started_at;
    this.endedAt = data.ended_at;
    this.requestedAt = data.requested_at;
    this.status = data.status;
    this.code = data.code;
  }
}
